var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ExpireHeader',{attrs:{"header":"สินค้าส่งคืนรอย้ายเข้าคลังรอคืน","img_header":_vm.header_image,"link_back":"stock/storage/expirestorage"}}),_c('Refun_product')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }